import { Stack, Card, CardMedia, CardContent, Button } from "@mui/material";
import CardGuiaReferencia from "../assets/images/Cards/Card-GuiaReferencia.jpg";
import CardReglamento from "../assets/images/Cards/Card-Reglamento.jpg";
import CardTabulador2 from "../assets/images/Cards/Card-Tabulador2.jpg";
import CardCalendario from "../assets/images/Cards/Card-Calendario.jpg";
import styled from "@emotion/styled";
import { FiDownload } from "react-icons/fi";
import { motion } from "framer-motion";

const CardsResources = () => {
  const cards = [
    {
      id: 1,
      title: "GUÍA DE REFERENCIA DEL ASOCIADO",
      imgSrc: CardGuiaReferencia,
      link: "https://drive.google.com/file/d/1Hc6XB2quGzgSUj17WTd26DAwR-ubWWt9/view?usp=sharing",
    },
    {
      id: 2,
      title: "REGLAMENTO NACIONAL DE CAPACITACIÓN",
      imgSrc: CardReglamento,
      link: "https://drive.google.com/file/d/1XfV_EJJqlsm0JXWrwM1xHLi1-bxlpSrt/view?usp=sharing",
    },
    {
      id: 3,
      title: "TABULADOR PUNTOS FORMACIÓN ACADÉMICA 2025",
      imgSrc: CardTabulador2,
      link: "https://drive.google.com/file/d/1VqcEDT1R6IGJpdFnYEr-X76F6I6Y2huf/view?usp=sharing",
    },
    {
      id: 4,
      title: "LOGROS CNC 2024",
      imgSrc: CardCalendario,
      link: "https://drive.google.com/file/d/1njktGWDm5IWsDf6-HteSmZz86pNjGTcg/view?usp=sharing",
    },
  ];

  const ResourcesDiv = styled(motion.div)`
    background: #ededed;
    padding: 50px 20px;
  `;

  const CardText = styled.p`
    font-family: "Oswald", serif;
    font-size: 17px;
    color: white;
    font-weight: 400;
    margin-bottom: 10px;
    text-align: center;
  `;

  const ButtonText = styled.p`
    font-family: "Oswald", serif;
    font-size: 17px;
    color: black;
    line-height: 15px;
    margin: 0;
    font-weight: 400;
  `;

  const handleDownload = (linkCard) => {
    window.open(linkCard, "_blank");
  };

  return (
    <ResourcesDiv
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        flexWrap="wrap"
        useFlexGap
        sx={{ gap: "32px" }}
      >
        {cards.map((card) => (
          <Card
            key={card.id}
            sx={{
              width: 250,
              position: "relative",
              textAlign: "center",
              boxShadow: 4,
            }}
          >
            <CardMedia
              component="img"
              height="300"
              image={card.imgSrc}
              alt={card.title}
            />
            <CardContent
              sx={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                background: "linear-gradient(0.5turn, transparent, black)",
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px",
                textAlign: "center",
              }}
            >
              <CardText>{card.title}</CardText>
              <Button
                variant="contained"
                onClick={() => handleDownload(card.link)}
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  height: "40px",
                  borderRadius: "30px",
                  "&:hover": { backgroundColor: "grey", color: "white" },
                  padding: "0px 30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <ButtonText>DESCARGAR</ButtonText>
                <FiDownload color="black" size={20} />
              </Button>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </ResourcesDiv>
  );
};

export default CardsResources;
